import { render, staticRenderFns } from "./LoadingDialogStandalone.vue?vue&type=template&id=07b58904"
import script from "./LoadingDialogStandalone.vue?vue&type=script&lang=js"
export * from "./LoadingDialogStandalone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports